module.exports = __webpack_public_path__ + "static/media/20.bdd899e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/20.wav
// module id = 9dUu
// module chunks = 0